import React, {PropTypes} from "react";
import RaisedButton from 'material-ui/RaisedButton';
import axios from "axios";
import MainPage from "./MainPage";
import SecondaryPage from "./SecondaryPage";

import ButtonTest from "./ButtonTest";
let styles = {

}

class Test extends React.Component {

  constructor(props) {
    super(props);

    this.state={counter: 0,size: 10,title: "HEADING DYNAMIC"};
    this.onButtonClick = this.onButtonClick.bind(this);

  }
// this is called before the component mounts
  componentWillMount()
  {
    //to know that the component is mounting
    //you don't much operations here
    // you are not allowed to set state or set props here
    // do it in the constructor or default
    console.log("COMPONENT WILL MOUNT IS CALLED")
  }
//after component has mounted
  componentDidMount()
  {
    // here you can change state
    // you make you initial API calls here
    // called only once
    //make api call here
    //set state of counter

    console.log("COMPONENT MOUNTED");
  }

  onButtonClick(title,counter)

  {
    //make an api call here
    this.setState({counter: counter+1,title: title})

  }
  renderButtons()
  {

    return
  }



  render() {
    let newListArray = new Array();
    let i =0;
    while(i<this.state.size)
    {
      newListArray[i] = new Object();
      newListArray[i].buttonName = "Button Name" + this.state.counter;
      newListArray[i].buttonValue = Math.random()%100;
      i++;
    }
    newListArray[5].buttonValue = 0;
    let title="Something";
  console.log(this.props);
    return (

      <div style={{backgroundColor: "white"}}>
        <h1>Heading 1</h1>

        <h3>{this.state.counter}</h3>
        <br/>

        {this.state.flag? <div>
            <ButtonTest button={node} onClick={this.onButtonClick}/>
            <br/>
            </div>:false}


        <button onClick={(event)=>{
          console.log(event);
          this.onButtonClick(title,this.state.counter);
        }} />
      </div>
    );
  }
}


Test.propTypes = {

};

export default Test;





/** WEBPACK FOOTER **
 ** ./src/components/Test.js
 **/